import './index.scss'

$(document).ready(function(){
  $('.section2 .left ul li').eq(0).addClass('active').find('.desc').slideDown(300)
  $('.section2 .left ul li .title').on('click',function(){
    let $parent = $(this).closest('li')
    if(!$parent.hasClass('active')){
      $parent.siblings().removeClass('active').find('.desc').slideUp(300)
      $parent.addClass('active').find('.desc').slideDown(300)
    }
  })
})